import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputPinCode from "../../components/welcome/InputPinCode";
import {
	validateTokenConfirmPhoneRequest,
	sendTokenRequest,
	sendRegisterCelPhoneRequest,
	failPincodeNewAccount,
} from "../../store/modules/confirmToken/actions";
import OnboardStep from "../OnboardStep";
import ZendeskChat from "../../components/ReactZenDeskChat";
import {
	ButtonContainer,
	ButtonRecover,
	Container,
	ContainerPinCode,
	Content,
	DivButtonConfirm,
	DivTimer,
	Label,
	Main,
	MessageError,
	Subtitle,
	Title,
} from "./styles";
import HttpService from "../../services/HttpService";
import whatsAppIcon from "../../assets/WhatsApp.svg";
import smsIcon from "../../assets/SMS.svg";
import history from "../../services/history";
import { convertSecondsInMinutes } from "../../utils";

export default function ConfirmePhone() {
	useEffect(() => {
		calcIntervalResendPincode();
	}, []);

	const dispatch = useDispatch();
	const vl_full_phone_number =
		useSelector((state) => state.recoverPassword.vl_full_phone_number) ||
		sessionStorage.getItem("vl_full_phone_number").replace(/\D/g, "");
	const { failPinCodeAccount, respSendRegisterCelPhone, respResendPhoneConfirmation } = useSelector(
		(state) => state.confirmToken
	);

	const [resendCode, setResendCode] = useState(false);
	const [timerResend, setTimerResend] = useState("00:00");

	const onboardAbandoned = (e) => {
		e.preventDefault();
	};

	useEffect(() => {
		if (sessionStorage.getItem("IS_ABANDONADED")) history.push("/onboard/login");

		window.addEventListener("popstate", onboardAbandoned);

		return () => {
			window.removeEventListener("popstate", onboardAbandoned);
			if (document.location.pathname === "/onboard/welcome") {
				HttpService.setAbandonedOnboardStatus();
				sessionStorage.setItem("IS_ABANDONADED", true);
			}
		};
	}, []);

	useEffect(() => {
		if (respSendRegisterCelPhone || respResendPhoneConfirmation) {
			const time =
				respSendRegisterCelPhone.next_interation || respResendPhoneConfirmation.seconds;
			calcIntervalResendPincode(time);
		}
	}, [respSendRegisterCelPhone, respResendPhoneConfirmation]);

	function maskPhone(number) {
		if (!number) return;
		let numberFormated = `(**) ***** - ${number.substring(9, number.length)}`;
		return numberFormated;
	}

	function calcIntervalResendPincode(timer = 30) {
		let controlTimer = timer;

		setTimerResend(`00:00`);
		setResendCode(true);

		const intervaloResend = setInterval(() => {
			setTimerResend(convertSecondsInMinutes(controlTimer--));

			if (controlTimer <= 0) {
				controlTimer = 0;
				setTimerResend(controlTimer);
				setResendCode(false);
				clearInterval(intervaloResend);
			}
		}, 1000);
	}

	function tokenConfirmation(token) {
		dispatch(validateTokenConfirmPhoneRequest(token));
	}

	function sendPhone(num) {
		dispatch(sendTokenRequest(num));
	}

	function sendWhastsApp() {
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		dispatch(sendRegisterCelPhoneRequest(cd_access_token, vl_full_phone_number, "web", "WHATSAPP"));
	}

	function change() {
		dispatch(failPincodeNewAccount(false));
	}

	return (
		<Main>
			<OnboardStep step={2} />
			<Container>
				<Content>
					<Title>Criar uma conta</Title>
					<Subtitle>
						Digite o código enviado para{" "}
						<b>{maskPhone(vl_full_phone_number)}</b>
					</Subtitle>
					<ContainerPinCode>
						<InputPinCode
							onSubmit={(pin) => tokenConfirmation(pin)}
							error={failPinCodeAccount}
							newLayout={true}
							onChangePin={change}
						/>
						{failPinCodeAccount ? (
							<MessageError>
								Código inválido, revise e tente
								novamente
							</MessageError>
						) : null}
					</ContainerPinCode>

					{!resendCode ? (
						<ButtonContainer>
							<Label>Reenviar código por:</Label>
							<DivButtonConfirm>
								<ButtonRecover
									onClick={() => {
										sendPhone(
											vl_full_phone_number
										);
									}}
								>
									<img
										src={smsIcon}
										alt="SMS icone"
									/>
									SMS
								</ButtonRecover>
								<ButtonRecover
									onClick={() => {
										sendWhastsApp();
									}}
								>
									<img
										src={whatsAppIcon}
										alt="WhatsApp icone"
									/>
									WhatsApp
								</ButtonRecover>
							</DivButtonConfirm>
						</ButtonContainer>
					) : (
						<DivTimer>
							<span>
								Receba um novo código em{" "}
								<strong>{timerResend}</strong>
							</span>
						</DivTimer>
					)}
					<ZendeskChat alwaysShow />
				</Content>
			</Container>
		</Main>
	);
}
